<template>
  <NuxtLink :to="getItemLinkWithExterior({name: item.market_hash_name, slug: item.link})"
            class="thumb">
    <!--    <div-->
    <!--        :style="-->
    <!--          item.rarity_color-->
    <!--            ? `background: radial-gradient(circle, ${item.rarity_color} 0%, rgba(0, 0, 0, 0) 60%);`-->
    <!--            : null-->
    <!--      "-->
    <!--        class="shadow"-->
    <!--    ></div>-->

    <img :alt="item.market_hash_name"
         :loading="loading || 'lazy'"
         :src="getImageFromWaxpeer(item.market_hash_name, '100:100')"
    />
  </NuxtLink>

</template>

<script lang="ts" setup>
import {useI18n} from 'vue-i18n'
import {getImageFromWaxpeer} from "~/utils/get-image-url";
import type {CompareItem} from "~/graphql/generated/schema-types";

const {t, locale} = useI18n()

const props = defineProps<{
  item: CompareItem,
  loading?: 'lazy' | 'eager'
}>()
</script>

<style lang="scss" scoped>


.thumb {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 70px;
  height: 44px;
  flex-shrink: 0;

  //.shadow {
  //  content: '';
  //  display: block;
  //  position: absolute;
  //  width: 100%;
  //  top: 0;
  //  bottom: 0;
  //  left: 0;
  //  background: radial-gradient(circle, currentColor 0%, rgba(0, 0, 0, 0) 60%);
  //  opacity: 0.2;
  //}

  img {
    object-position: center;
    object-fit: contain;
    width: 70px;
    height: 44px;
  }

  @media screen and (max-width: 768px) {
    margin-left: 0;
  }
}
</style>
